/* Tea Lab Header 2: mobile drawer, dropdown toggles and sticky behaviour.
   One custom element per header; everything it adds to the page is removed again when it leaves, so the theme editor can re-render it freely. */
(function () {
  if (customElements.get('tea-lab-header-2')) return;

  class TeaLabHeader2 extends HTMLElement {
    connectedCallback() {
      if (this._on) return;
      this._on = true;
      this._off = [];
      this._drawer();
      this._dropdowns();
      this._search();
      this._sticky();
    }

    disconnectedCallback() {
      this._on = false;
      (this._off || []).forEach(function (fn) { try { fn(); } catch (e) {} });
      this._off = [];
      document.documentElement.classList.remove('tlh2-lock');
    }

    _listen(target, type, fn, opts) {
      if (!target) return;
      target.addEventListener(type, fn, opts);
      this._off.push(function () { target.removeEventListener(type, fn, opts); });
    }

    /* ---------- mobile drawer ---------- */
    _drawer() {
      var self = this;
      var burger = this.querySelector('[data-tlh2-open]');
      var drawer = this.querySelector('[data-tlh2-drawer]');
      var overlay = this.querySelector('[data-tlh2-overlay]');
      if (!burger || !drawer) return;
      var closeBtn = drawer.querySelector('[data-tlh2-close]');

      function focusables() {
        return Array.prototype.slice.call(drawer.querySelectorAll('a[href],button:not([disabled]),input:not([disabled])'))
          .filter(function (el) { return el.offsetParent !== null || el === document.activeElement; });
      }
      function open() {
        drawer.classList.add('is-open');
        if (overlay) overlay.classList.add('is-open');
        drawer.removeAttribute('inert');
        drawer.setAttribute('aria-hidden', 'false');
        burger.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('tlh2-lock');
        window.setTimeout(function () { if (closeBtn) closeBtn.focus(); }, 30);
      }
      function close(returnFocus) {
        if (!drawer.classList.contains('is-open')) return;
        drawer.classList.remove('is-open');
        if (overlay) overlay.classList.remove('is-open');
        drawer.setAttribute('inert', '');
        drawer.setAttribute('aria-hidden', 'true');
        burger.setAttribute('aria-expanded', 'false');
        document.documentElement.classList.remove('tlh2-lock');
        if (returnFocus !== false) burger.focus();
      }
      this._closeDrawer = close;

      this._listen(burger, 'click', function () { drawer.classList.contains('is-open') ? close() : open(); });
      this._listen(closeBtn, 'click', function () { close(); });
      this._listen(overlay, 'click', function () { close(); });
      this._listen(document, 'keydown', function (e) {
        if (!drawer.classList.contains('is-open')) return;
        if (e.key === 'Escape') { close(); return; }
        if (e.key !== 'Tab') return;
        var items = focusables();
        if (!items.length) return;
        var first = items[0], last = items[items.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      });
      var mq = window.matchMedia ? window.matchMedia('(min-width: 900px)') : null;
      if (mq) {
        var onMq = function () { if (mq.matches) close(false); };
        if (mq.addEventListener) { mq.addEventListener('change', onMq); this._off.push(function () { mq.removeEventListener('change', onMq); }); }
      }

      Array.prototype.forEach.call(drawer.querySelectorAll('[data-tlh2-dtoggle]'), function (btn) {
        self._listen(btn, 'click', function () {
          var sub = document.getElementById(btn.getAttribute('aria-controls'));
          if (!sub) return;
          var isOpen = !sub.classList.contains('is-open');
          sub.classList.toggle('is-open', isOpen);
          btn.setAttribute('aria-expanded', String(isOpen));
        });
      });
    }

    /* ---------- desktop dropdowns (hover and focus work in CSS, these make touch and keyboard reliable) ---------- */
    _dropdowns() {
      var self = this;
      var items = Array.prototype.slice.call(this.querySelectorAll('.tlh2__item.has-sub'));
      if (!items.length) return;
      function closeAll(except) {
        items.forEach(function (li) {
          if (li === except) return;
          li.classList.remove('is-open');
          var b = li.querySelector('[data-tlh2-chev]');
          if (b) b.setAttribute('aria-expanded', 'false');
        });
      }
      items.forEach(function (li) {
        var b = li.querySelector('[data-tlh2-chev]');
        if (!b) return;
        self._listen(b, 'click', function (e) {
          e.preventDefault();
          var isOpen = !li.classList.contains('is-open');
          closeAll(li);
          li.classList.toggle('is-open', isOpen);
          b.setAttribute('aria-expanded', String(isOpen));
        });
      });
      this._listen(document, 'click', function (e) { if (!self.contains(e.target)) closeAll(null); });
      this._listen(document, 'keydown', function (e) {
        if (e.key !== 'Escape') return;
        var openLi = items.filter(function (li) { return li.classList.contains('is-open'); })[0];
        closeAll(null);
        if (openLi) { var b = openLi.querySelector('[data-tlh2-chev]'); if (b) b.focus(); }
      });
    }

    /* ---------- live search panel ---------- */
    _search() {
      var self = this;
      var root = this.querySelector('[data-tlh2-sx]');
      var openers = Array.prototype.slice.call(this.querySelectorAll('[data-tlh2-sx-open]'));
      if (!root || !openers.length) return;
      var panel = root.querySelector('.tlh2__sx-panel');
      var input = root.querySelector('input[type="search"]');
      var pop = root.querySelector('[data-tlh2-sx-pop]');
      var res = root.querySelector('[data-tlh2-sx-res]');
      var status = root.querySelector('[data-tlh2-sx-status]');
      var base = root.getAttribute('data-suggest') || '/search/suggest';
      var currency = root.getAttribute('data-currency') || 'PKR';
      var limit = parseInt(root.getAttribute('data-limit'), 10) || 4;
      var withColl = root.getAttribute('data-collections') !== 'false';
      var L = {
        all: root.getAttribute('data-l-all') || 'View all results',
        none: root.getAttribute('data-l-none') || 'No matches found. Try another word.',
        products: root.getAttribute('data-l-products') || 'Teas',
        collections: root.getAttribute('data-l-collections') || 'Collections'
      };
      var opener = null, timer = null, ctrl = null, lastQ = '';

      function el(tag, cls, text) {
        var n = document.createElement(tag);
        if (cls) n.className = cls;
        if (text != null) n.textContent = text;
        return n;
      }
      function money(v) {
        var n = parseFloat(v);
        if (isNaN(n)) return '';
        try {
          return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: currency, maximumFractionDigits: n % 1 ? 2 : 0 }).format(n);
        } catch (e) { return currency + ' ' + n; }
      }
      function sized(url, w) {
        if (!url) return '';
        return url.replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '') + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
      }
      function imgOf(p) {
        if (p.featured_image && p.featured_image.url) return p.featured_image.url;
        return p.image || '';
      }
      function open(from) {
        opener = from || opener;
        root.classList.add('is-open');
        root.removeAttribute('inert');
        root.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('tlh2-lock');
        openers.forEach(function (o) { o.setAttribute('aria-expanded', 'true'); });
        if (input.value) { input.value = ''; lastQ = ''; showIdle(); }   /* every opening starts fresh */
        window.setTimeout(function () { input.focus(); }, 40);
      }
      function close(returnFocus) {
        if (!root.classList.contains('is-open')) return;
        root.classList.remove('is-open');
        root.setAttribute('inert', '');
        root.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('tlh2-lock');
        openers.forEach(function (o) { o.setAttribute('aria-expanded', 'false'); });
        if (ctrl && ctrl.abort) ctrl.abort();
        window.clearTimeout(timer);
        if (returnFocus !== false && opener) opener.focus();
      }
      function showIdle() {
        if (pop) pop.hidden = false;
        res.hidden = true;
        res.textContent = '';
        status.textContent = '';
      }
      function product(p) {
        var a = el('a', 'tlh2__sx-card');
        a.href = p.url;
        var wrap = el('span', 'tlh2__sx-img');
        var u = imgOf(p);
        if (u) {
          var im = document.createElement('img');
          im.src = sized(u, 360); im.alt = ''; im.loading = 'lazy'; im.width = 360; im.height = 360;
          wrap.appendChild(im);
        }
        a.appendChild(wrap);
        a.appendChild(el('span', 'tlh2__sx-t', p.title));
        var price = el('span', 'tlh2__sx-p', money(p.price));
        var was = parseFloat(p.compare_at_price_max || p.compare_at_price);
        if (was && was > parseFloat(p.price)) { var s = el('s', null, money(was)); price.appendChild(s); }
        a.appendChild(price);
        return a;
      }
      function render(q, r) {
        var prods = (r.products || []).slice(0, limit);
        var colls = withColl ? (r.collections || []).slice(0, 4) : [];
        res.textContent = '';
        if (pop) pop.hidden = true;
        if (!prods.length && !colls.length) {
          res.appendChild(el('p', 'tlh2__sx-empty', L.none));
          status.textContent = L.none;
        } else {
          if (prods.length) {
            var sec = el('div', 'tlh2__sx-sec');
            sec.appendChild(el('p', 'tlh2__sx-label', L.products));
            var grid = el('div', 'tlh2__sx-grid');
            prods.forEach(function (p) { grid.appendChild(product(p)); });
            sec.appendChild(grid);
            res.appendChild(sec);
          }
          if (colls.length) {
            var sec2 = el('div', 'tlh2__sx-sec');
            sec2.appendChild(el('p', 'tlh2__sx-label', L.collections));
            var chips = el('div', 'tlh2__sx-chips');
            colls.forEach(function (c) { var a = el('a', 'tlh2__sx-chip', c.title); a.href = c.url; chips.appendChild(a); });
            sec2.appendChild(chips);
            res.appendChild(sec2);
          }
          var more = el('a', 'tlh2__sx-more', L.all);
          more.href = input.form.action + '?q=' + encodeURIComponent(q);
          res.appendChild(more);
          status.textContent = (prods.length + colls.length) + ' ' + (L.products || '').toLowerCase();
        }
        res.hidden = false;
        root.removeAttribute('aria-busy');
      }
      function run(q) {
        if (ctrl && ctrl.abort) ctrl.abort();
        ctrl = window.AbortController ? new AbortController() : null;
        root.setAttribute('aria-busy', 'true');
        var url = base + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection&resources[limit]=' + limit + '&resources[limit_scope]=each';
        fetch(url, { headers: { Accept: 'application/json' }, signal: ctrl ? ctrl.signal : undefined })
          .then(function (r) { if (!r.ok) throw new Error('search ' + r.status); return r.json(); })
          .then(function (d) { if (q === lastQ) render(q, (d && d.resources && d.resources.results) || {}); })
          .catch(function (err) {
            if (err && err.name === 'AbortError') return;
            root.removeAttribute('aria-busy');
            res.textContent = '';
            var a = el('a', 'tlh2__sx-more', L.all); a.href = input.form.action + '?q=' + encodeURIComponent(q);
            res.appendChild(a); res.hidden = false; if (pop) pop.hidden = true;
          });
      }
      function onInput() {
        var q = input.value.trim();
        lastQ = q;
        window.clearTimeout(timer);
        if (q.length < 2) { if (ctrl && ctrl.abort) ctrl.abort(); root.removeAttribute('aria-busy'); showIdle(); return; }
        timer = window.setTimeout(function () { run(q); }, 200);
      }

      openers.forEach(function (o) {
        self._listen(o, 'click', function (e) { e.preventDefault(); open(o); });
      });
      Array.prototype.forEach.call(root.querySelectorAll('[data-tlh2-sx-close]'), function (b) {
        self._listen(b, 'click', function () { close(); });
      });
      self._listen(input, 'input', onInput);
      Array.prototype.forEach.call(root.querySelectorAll('[data-term]'), function (b) {
        self._listen(b, 'click', function () { input.value = b.getAttribute('data-term'); input.focus(); lastQ = input.value.trim(); window.clearTimeout(timer); run(lastQ); });
      });
      /* keep the page behind from scrolling while the panel is open (wide screens scroll .page-wrapper, not the window) */
      var bg = root.querySelector('.tlh2__sx-bg');
      self._listen(bg, 'wheel', function (e) { e.preventDefault(); }, { passive: false });
      self._listen(bg, 'touchmove', function (e) { e.preventDefault(); }, { passive: false });
      self._listen(document, 'keydown', function (e) {
        if (!root.classList.contains('is-open')) return;
        if (e.key === 'Escape') { e.preventDefault(); close(); return; }
        if (e.key !== 'Tab') return;
        var items = Array.prototype.slice.call(panel.querySelectorAll('a[href],button:not([disabled]),input:not([disabled])')).filter(function (n) { return n.offsetParent !== null; });
        if (!items.length) return;
        var first = items[0], last = items[items.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      });
      this._off.push(function () { document.documentElement.classList.remove('tlh2-lock'); window.clearTimeout(timer); if (ctrl && ctrl.abort) ctrl.abort(); });
    }

    /* ---------- sticky ----------
       This theme scrolls .page-wrapper (not the window) on wide screens, which breaks position:sticky. So the header switches to
       position:fixed once the page has scrolled past it, and a spacer keeps the page from jumping. */
    _sticky() {
      var self = this;
      var mode = this.getAttribute('data-sticky');
      if (!mode || mode === 'none') return;
      var shell = this.querySelector('[data-tlh2-shell]');
      var spacer = this.querySelector('[data-tlh2-spacer]');
      if (!shell) return;
      var wrap = document.querySelector('.page-wrapper');
      var naturalTop = 0, naturalH = 0, lastY = 0, ticking = false;
      var floating = this.getAttribute('data-transparent') === 'on';   /* see-through header takes no room in the page, so no spacer */

      function scroller() {
        return (wrap && getComputedStyle(wrap).overflowY === 'auto') ? wrap : null;
      }
      function y() {
        var s = scroller();
        return s ? s.scrollTop : (window.pageYOffset || document.documentElement.scrollTop || 0);
      }
      function setStuck(on) {
        if (on === self.classList.contains('is-stuck')) return;
        self.classList.toggle('is-stuck', on);
        if (spacer) spacer.style.height = (on && !floating) ? naturalH + 'px' : '0px';
        if (!on) self.classList.remove('is-hidden');
      }
      function measure() {
        var wasStuck = self.classList.contains('is-stuck');
        if (wasStuck) { self.classList.remove('is-stuck', 'is-hidden'); if (spacer) spacer.style.height = '0px'; }
        var r = shell.getBoundingClientRect();
        var cur = y();
        naturalTop = r.top + cur;
        naturalH = shell.offsetHeight;
        if (cur > naturalTop) setStuck(true);
      }
      function onScroll() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          ticking = false;
          var cur = y();
          var stick = cur > naturalTop;
          setStuck(stick);
          if (mode === 'smart' && stick) {
            if (cur > lastY && cur - naturalTop > 120) self.classList.add('is-hidden');
            else if (cur < lastY) self.classList.remove('is-hidden');
          }
          lastY = cur;
        });
      }

      measure();
      this._listen(window, 'load', measure);
      this._listen(window, 'resize', measure, { passive: true });
      this._listen(window, 'scroll', onScroll, { passive: true });
      this._listen(wrap, 'scroll', onScroll, { passive: true });
      if (window.ResizeObserver) {
        var ro = new ResizeObserver(function () { if (!self.classList.contains('is-stuck')) measure(); });
        ro.observe(shell);
        this._off.push(function () { ro.disconnect(); });
      }
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { if (self._on) measure(); });

      /* keep the header visible while keyboard focus is inside it */
      this._listen(shell, 'focusin', function () { self.classList.remove('is-hidden'); });
    }
  }

  customElements.define('tea-lab-header-2', TeaLabHeader2);
})();